import { Subject } from 'rxjs';
import { Product } from '../../config/product';
import { Translations } from '../../config/translations';
import { IUpSellCallbacks, IUpSellResponse } from '../../config/upsell-response';
import { View } from '../view';

export class UpSellView extends View {

    upSellResponse: IUpSellResponse = {};
    callbacks: IUpSellCallbacks = {};
    selectedProducts: Product[] = [];
    upSellSubject: Subject<any> | undefined;

    currency = '';
    container = this.getDFContainer();
    totalContainer = document.createElement('div');

    render(upSellResponse: IUpSellResponse, currency: string, callbacks: IUpSellCallbacks, upSellFormSubject: Subject<any>) {
        this.upSellResponse = upSellResponse;
        this.callbacks = callbacks;
        this.currency = currency;
        this.upSellSubject = upSellFormSubject;

        this.initFormElements();

        this.upSellSubject.subscribe(res => {
            this.renderTotal(res);
        });
    }

    initFormElements() {
        this.renderHeaderTitle();
        this.renderUpSellActions();
    }

    renderHeaderTitle() {
        const titleContainer = document.createElement('div');
        titleContainer.classList.add('hs-form-field');
        const createTitle = document.createElement('h2');
        if (this.upSellResponse.products) {
            createTitle.innerText = this.upSellResponse.products[0].title || '';
        }
        titleContainer.appendChild(createTitle);
        this.container.prepend(titleContainer);
    }

    renderTotal(cost: { total: number, currency: string, tax: number }) {
        this.totalContainer.classList.add('df-upsell-total-container', 'hs-form-field');
        this.totalContainer.innerHTML = `
        <div class="upsell-total-container">
            ${cost.tax > 0 ?
                `<div class='df-subtotal-tax'>
                <div class="df-f-label-container">
                    <span class='df-f-label' data-label="tax">${Translations.TAX}</span> (<span class='tax-rate df-f-label'></span>%):
                </div>
                <div class="df-f-value-container">
                    <span class='amount df-f-value'>${cost.tax}</span>
                </div>
            </div>` : ''}

            <div class='df-final-total'>
                <div class="df-f-label-container">
                    <span class='df-final-amount-label df-f-label' data-label="total">${Translations.TOTAL}</span>
                </div>
                <div class="df-f-value-container">
                    <span id='df-final-amount' class='df-final-amount df-f-value'>${this.formatMoney(cost.total.toString(), this.currency)}</span>
                    <span id='df-subscription-interval' class='df-f-value'></span>
                </div>
            </div>
        </div>
        `;
    }

    renderUpSellActions() {
        const actionContainer = document.createElement('div');
        actionContainer.id = 'df-actions-container';
        actionContainer.classList.add('df-actions-cotnainer', 'hs-form-field');

        const purchaseBtn = document.createElement('input');
        purchaseBtn.type = 'button';
        purchaseBtn.classList.add('df-input', 'hs-input', 'upsell-purchase');
        purchaseBtn.value = this.upSellResponse.products && this.upSellResponse.products[0].purchaseText || 'Yes';
        purchaseBtn.addEventListener('click', (ev) => {
            if (this.callbacks.onPurchaseAction) {
                this.callbacks.onPurchaseAction(ev);
            }
        });

        const skipBtn = document.createElement('input');
        skipBtn.type = 'button';
        skipBtn.classList.add('df-input', 'hs-input', 'upsell-skip');
        skipBtn.value = this.upSellResponse.products && this.upSellResponse.products[0].skipText || 'No, thanks';
        skipBtn.addEventListener('click', (ev) => {
            if (this.callbacks.onSkipAction) {
                this.callbacks.onSkipAction(ev);
            }
        });

        actionContainer.appendChild(purchaseBtn);
        actionContainer.appendChild(skipBtn);

        this.container.appendChild(this.totalContainer);
        this.container.appendChild(actionContainer);
    }

}
